import React from 'react';

const Divider = () => <div className="ws-ui-editor-header__divider" />;

export default Divider;
